import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M7 13h4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M15 13h2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M7 9h2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M13 9h4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10Z",
            stroke: `${color}`
          }
        )
      ]
    }
  );
};
Icon.displayName = "Subtitles";
const Subtitles = memo(themed(Icon));
export {
  Subtitles
};
//# sourceMappingURL=subtitles.js.map
